export enum LinkedFieldTypeEnum {
  CATEGORY = 'CATEGORY',
  SOUNDTRACK = 'SOUNDTRACK',
  URL = 'URL',
}
